export default __webpack_public_path__ + "idin_logo.png";